module.exports = __webpack_public_path__ + "media/images/institucional/organigrama_ioscor-d4747c51ac71b1bc3c93409a9f96177f.jpg";